var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$route.query.groupId && !_vm.$route.query.companyID)?_c('router-link',{staticClass:"btn dealers_btn",attrs:{"to":{
      name: 'UserDetails',
      query: {
        userId: _vm.data.id,
        username: _vm.data.email,
        name: ((_vm.data.firstName) + " " + (_vm.data.lastName)),
        companyId: _vm.$route.query.companyId,
      },
    }}},[_vm._v("\n    "+_vm._s(_vm.$t("text.actionButtons.edit"))+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.$route.query.companyID && !_vm.$route.query.groupId)?_c('router-link',{staticClass:"btn dealers_btn",attrs:{"to":{
      name: 'industrial_admin_user_details',
      query: {
        userId: _vm.data.id,
        username: _vm.data.email,
        name: ((_vm.data.firstName) + " " + (_vm.data.lastName)),
        companyID: _vm.$route.query.companyID,
      },
    }}},[_vm._v("\n    "+_vm._s(_vm.$t("text.actionButtons.edit"))+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.$route.query.groupId)?_c('button',{staticClass:"btn dealers_btn",on:{"click":function($event){return _vm.unmapFromGroup(_vm.data)}}},[_vm._v("\n    "+_vm._s(_vm.$t("text.clickButtons.unmapFromGroup"))+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }